import React, { useEffect, useState } from "react";
import "./Post.css";

import db from "./firebase";
import PostSelf from "./PostSelf";
import { Link } from "react-router-dom";
import Pagination from "./Pagination";
import Footer from "./Footer";

const Post = (props) => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(6);

  useEffect(() => {
    db.collection("posts")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setPosts(
          snapshot.docs.map((doc) => ({ id: doc.id, post: doc.data() }))
        );
      });
  }, []);

  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const currentPost = posts.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className='flex flex-wrap justify-center items-center mt-7 '>
        {currentPost.map((post) => (
          <div className='post transition-all delay-100 ease-in flex bg-color rounded-xl shadow-2xl m-3 mt-4 md:w-80 xs:w-96'>
            <Link className='text-decoration-none' to={`/post/${post.id}`}>
              <PostSelf
                comments={props.comments}
                key={post.id}
                type={post.post.type}
                text={post.post.text}
                date={post.post.date}
                location={post.post.location}
                image={post.post.image}
              />
            </Link>
          </div>
        ))}
      </div>
      <div className='flex justify-center items-center md:p-6 xs:p-3 md:mt-8 xs:mt-2'>
        <Pagination
          size='small'
          postPerPage={postPerPage}
          totalPost={posts.length}
          paginate={paginate}
        />
      </div>

      <Footer />
    </>
  );
};

export default Post;
